import { apiCall, ApiConfig } from '../../config/api'
import { Courier } from '../../interfaces/Courier/Courier'
import { getCouriersAction } from '../actions/courierActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { GET_COURIERS } from '../types/courierActionsTypes'

export function* getCouriersAsync() {
  try {
    const { status, data }: AxiosResponse<Courier[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.CourierApi}/GetList`
    )
    if (status === 200) {
      yield put(getCouriersAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getCouriersAction([], serverError.message))
  }
}

export function* watchGetCouriersAsync() {
  yield takeEvery(GET_COURIERS, getCouriersAsync)
}
